import { Button, DatePicker, Form, Input, InputNumber, message, Modal, Select } from 'antd';
import { WrappedFormUtils } from 'antd/lib/form/Form';
import gql from 'graphql-tag';
import * as moment from 'moment';
import React, { Component } from 'react';
import { Mutation } from 'react-apollo';

import { marketingActivityQuery } from '../group/GroupDetail';
import { MarketActivityType } from './MarketActivites';

export enum MarketActivityStatus {
  NEW,
  ONLINE,
  OFFLINE,
}

const formItemLayout = {
  labelCol: {
    xs: { span: 24 },
    sm: { span: 6 },
  },
  wrapperCol: {
    xs: { span: 24 },
    sm: { span: 10 },
  },
};

export const createMarketingActivityMutation = gql`
  mutation createMarketingActivity(
    $name: String
    $desc: String
    $startTime: Date
    $endTime: Date
    $weight: Int
    $status: Int
    $type: Int
  ) {
    createMarketingActivity(
      name: $name
      desc: $desc
      startTime: $startTime
      endTime: $endTime
      weight: $weight
      status: $status
      type: $type
    ) {
      id
      name
      desc
      weight
    }
  }
`;
interface Props {
  form: WrappedFormUtils;
}
interface State {
  isShowAddMarketingActivityModal: boolean;
  type?: number;
  startTime?: Date;
  endTime?: Date;
  name: string;
  desc: string;
  weight?: number;
  status?: number;
}
export class AddMarketingActivity extends Component<Props, State> {
  constructor(props: Props) {
    super(props);
    this.state = {
      isShowAddMarketingActivityModal: false,
      name: '',
      desc: '',
    };
  }

  cancelAddMarketingActivity = () => {
    this.setState({ isShowAddMarketingActivityModal: false });
  };

  showAddActivityModal = () => {
    this.setState({ isShowAddMarketingActivityModal: true });
  };

  onActivityTypeChange = (value: number) => {
    this.setState({ type: value });
  };

  onActivityNameChange = (e: { target: { value: string } }) => {
    this.setState({ name: e.target.value });
  };

  onDescChange = (e: { target: { value: string } }) => {
    this.setState({ desc: e.target.value });
  };

  onStartTimeChange = (date: moment.Moment) => {
    this.setState({
      startTime: moment(date).startOf('day').utc().toDate(),
    });
  };

  onEndTimeChange = (date: moment.Moment) => {
    this.setState({
      endTime: moment(date).endOf('day').utc().toDate(),
    });
  };

  onActivityWeightChange = (value?: number) => {
    this.setState({ weight: value });
  };

  onActivityStatusChange = (value: number) => {
    this.setState({ status: value });
  };

  validateForm = () => {
    if (moment(this.state.endTime).valueOf < moment(this.state.startTime).valueOf) {
      message.warning('结束时间不能小于开始时间！');
    }
  };

  render() {
    const { getFieldDecorator } = this.props.form;
    const { name, desc, startTime, endTime, weight, status, type } = this.state;
    return (
      <>
        <Button type="primary" onClick={this.showAddActivityModal}>
          添加
        </Button>
        <Mutation
          variables={{ name, desc, startTime, endTime, weight, status, type }}
          mutation={createMarketingActivityMutation}
          refetchQueries={[{ query: marketingActivityQuery }]}
        >
          {createMarketingActivity => {
            return (
              <Modal
                title="添加活动"
                visible={this.state.isShowAddMarketingActivityModal}
                onOk={() => {
                  this.props.form.validateFields(async err => {
                    if (err) {
                      message.error(err);
                      return;
                    }
                    try {
                      await createMarketingActivity();
                      this.setState({ isShowAddMarketingActivityModal: false });
                      message.success('添加成功！');
                    } catch {
                      message.error('添加失败！');
                    }
                  });
                }}
                onCancel={this.cancelAddMarketingActivity}
              >
                <Form>
                  <Form.Item label="活动名称" {...formItemLayout}>
                    {getFieldDecorator('name', {
                      rules: [
                        {
                          required: true,
                          message: '请填写活动名称',
                        },
                      ],
                    })(<Input placeholder="活动名称" onChange={this.onActivityNameChange} />)}
                  </Form.Item>
                  <Form.Item {...formItemLayout} label="活动描述">
                    {getFieldDecorator('desc', {
                      rules: [
                        {
                          required: true,
                          message: '活动描述',
                        },
                      ],
                    })(<Input placeholder="活动描述" onChange={this.onDescChange} />)}
                  </Form.Item>
                  <Form.Item {...formItemLayout} label="开始时间">
                    {getFieldDecorator('startTime', {
                      rules: [
                        {
                          required: true,
                          message: '请填写活动开始时间',
                        },
                      ],
                    })(<DatePicker onChange={this.onStartTimeChange} />)}
                  </Form.Item>
                  <Form.Item {...formItemLayout} label="结束时间">
                    {getFieldDecorator('endTime', {
                      rules: [
                        {
                          required: true,
                          message: '请填写活动结束时间',
                        },
                      ],
                    })(<DatePicker onChange={this.onEndTimeChange} />)}
                  </Form.Item>
                  <Form.Item {...formItemLayout} label="活动优先级">
                    {getFieldDecorator('weight', {
                      rules: [
                        {
                          required: true,
                          message: '请填写活动活动优先级',
                        },
                      ],
                    })(<InputNumber onChange={this.onActivityWeightChange} />)}
                  </Form.Item>
                  <Form.Item {...formItemLayout} label="活动状态">
                    {getFieldDecorator('status', {
                      rules: [
                        {
                          required: true,
                          message: '请选择活动活动状态',
                        },
                      ],
                    })(
                      <Select onChange={this.onActivityStatusChange}>
                        <Select.Option key="online" value={MarketActivityStatus.ONLINE}>
                          开启
                        </Select.Option>
                        <Select.Option key="offline" value={MarketActivityStatus.OFFLINE}>
                          关闭
                        </Select.Option>
                      </Select>,
                    )}
                  </Form.Item>
                  <Form.Item {...formItemLayout} label="活动类型">
                    <Select placeholder="请选择活动类型" onChange={this.onActivityTypeChange}>
                      <Select.Option key="unknown" value={MarketActivityType.UNKNOWN}>
                        普通
                      </Select.Option>
                      <Select.Option key="preorder" value={MarketActivityType.PREORDER}>
                        预售
                      </Select.Option>
                      <Select.Option key="newPoint" value={MarketActivityType.NEW_POINT}>
                        新积分
                      </Select.Option>
                      <Select.Option key="point" value={MarketActivityType.POINT}>
                        积分
                      </Select.Option>
                      <Select.Option key="limitedTimeSale" value={MarketActivityType.LIMITED_TIME_SALE}>
                        限时优惠
                      </Select.Option>
                      <Select.Option key="reservation" value={MarketActivityType.RESERVATION}>
                        预定
                      </Select.Option>
                      <Select.Option key="double11" value={MarketActivityType.DOUBLE_11}>
                        双十一
                      </Select.Option>
                    </Select>
                  </Form.Item>
                </Form>
              </Modal>
            );
          }}
        </Mutation>
      </>
    );
  }
}



// WEBPACK FOOTER //
// ./src/screens/marketing/AddMarketingActivity.tsx